export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmação"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sim"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tem certeza de que deseja continuar?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluir criptoativo"])}
}